export enum RecertAssessmentSections {
  ASSESSMENT_OVERVIEW = 'assessment-overview',
  CERT_PERIOD_RECAP = 'cert-period-recap',
  SKILLED_NEEDS = 'skilled-needs',
  ADL_NEEDS = 'adl-needs',
  DISCHARGE_PLANNING = 'discharge-planning',
  AUTHORIZATION = 'authorization',
  PLAN_OF_CARE = 'plan-of-care',
  VISIT_SCHEDULING = 'visit-scheduling',
  MEDICATIONS = 'medications',
  VITALS = 'vitals',
  MEDICAL_BACKGROUND = 'medical-background',
  SUPERVISORY_REVIEW = 'supervisory-review',
  NARRATIVE = 'narrative',
  FINAL_STEPS = 'final-steps'
}

export const RecertAssessmentAnchors = [
  {
    key: RecertAssessmentSections.ASSESSMENT_OVERVIEW,
    href: '#assessment-overview',
    title: 'Assessment Overview'
  },
  {
    key: RecertAssessmentSections.CERT_PERIOD_RECAP,
    href: '#cert-period-recap',
    title: 'Cert Period Recap'
  },
  {
    key: RecertAssessmentSections.SKILLED_NEEDS,
    href: '#skilled-needs',
    title: 'Skilled Needs'
  },
  {
    key: RecertAssessmentSections.ADL_NEEDS,
    href: '#adl-needs',
    title: 'ADL Needs'
  },
  {
    key: RecertAssessmentSections.DISCHARGE_PLANNING,
    href: '#discharge-planning',
    title: 'Discharge Planning'
  },
  {
    key: RecertAssessmentSections.AUTHORIZATION,
    href: '#authorization',
    title: 'Authorization'
  },
  {
    key: RecertAssessmentSections.VISIT_SCHEDULING,
    href: '#visit-scheduling',
    title: 'Visit Scheduling'
  },
  {
    key: RecertAssessmentSections.PLAN_OF_CARE,
    href: '#plan-of-care',
    title: 'Plan of Care'
  },
  {
    key: RecertAssessmentSections.SUPERVISORY_REVIEW,
    href: '#supervisory-review',
    title: 'Supervisory Review'
  },
  {
    key: RecertAssessmentSections.MEDICATIONS,
    href: '#medications',
    title: 'Medications'
  },
  {
    key: RecertAssessmentSections.VITALS,
    href: '#vitals',
    title: 'Vitals'
  },
  {
    key: RecertAssessmentSections.MEDICAL_BACKGROUND,
    href: '#medical-background',
    title: 'Medical Background'
  },
  {
    key: RecertAssessmentSections.NARRATIVE,
    href: '#narrative',
    title: 'Narrative'
  },
  {
    key: RecertAssessmentSections.FINAL_STEPS,
    href: '#final-steps',
    title: 'Final Steps'
  }
]

// Add sections here as they are migrated from controlled to uncontrolled
export const UNCONTROLLED_FORM_SECTION: Set<RecertAssessmentSections> = new Set([
  RecertAssessmentSections.ASSESSMENT_OVERVIEW,
  RecertAssessmentSections.CERT_PERIOD_RECAP,
  RecertAssessmentSections.SKILLED_NEEDS,
  // RecertAssessmentSections.ADL_NEEDS,
  RecertAssessmentSections.DISCHARGE_PLANNING,
  RecertAssessmentSections.AUTHORIZATION,
  // RecertAssessmentSections.PLAN_OF_CARE,
  RecertAssessmentSections.VISIT_SCHEDULING,
  // RecertAssessmentSections.MEDICATIONS,
  RecertAssessmentSections.VITALS,
  RecertAssessmentSections.MEDICAL_BACKGROUND,
  // RecertAssessmentSections.SUPERVISORY_REVIEW,
  RecertAssessmentSections.NARRATIVE,
  RecertAssessmentSections.FINAL_STEPS
])
